{{#with context}}
{{#if hasMonitor}}
`ifndef DISABLE_INTERFACE_HARNESS_NOT_BOUND_WARNINGS
  if ({{ ../handle.identifier }} == 0) begin
    `uvm_warning(get_type_name(), "Without an interface the following services can not run: {{#if hasUvcCoverage}}coverage, {{/if}}monitor-based checks. Turn off this message, and others like it, by defining `DISABLE_INTERFACE_HARNESS_NOT_BOUND_WARNINGS.")
  end
`endif
{{/if}}
{{/with}}
